import { v4 as uuidv4 } from 'uuid'

import type { CookieInterface } from '@app/services/CookieManager'

import { createCookieName } from './cookieNames'
import { createCookie } from './cookies'
import moment from './moment'

const deviceIdCookie = createCookie<string | null>(
  createCookieName('kidsout__device_id'),
  v => v || null,
  v => v ?? '',
  // Not consent-gated: without this the write is buffered until the banner is accepted, so
  // every server-side login (email link, code, exchange) mints a fresh id and the backend
  // sees a new device each time.
  () => ({ expires: moment().add(10, 'years'), sameSite: 'lax', ignoreConsent: true })
)

export async function getOrCreateDeviceId(cookies: CookieInterface): Promise<string> {
  const existing = await deviceIdCookie.get(cookies)
  if (existing) return existing
  const next = uuidv4()
  await deviceIdCookie.set(cookies, next)
  return next
}
